"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWithUpdate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FormItem_1 = require("../FormItem");
const tech_1 = require("../../../tech");
const FormProvider_1 = require("../FormProvider");
const Alerts_1 = require("../../../tech/Alerts");
const react_ui_1 = require("@pasport/react-ui");
const FormWithUpdate = ({ initValues, dispatchUpdate, onUpdateSuccess, dispatchDelete, onDeleteSuccess, children, defaultFormMode, onResetPress }) => {
    const [mode, setMode] = (0, react_1.useState)(defaultFormMode ?? FormItem_1.FormMode.VIEW);
    const { fetchApiState: updateFetch, apiState: updateApiState } = (0, tech_1.useApiState)();
    const { fetchApiState: deleteFetch, apiState: deleteApiState } = (0, tech_1.useApiState)();
    const [isDeleteModalVisible, setIsDeleteModalVisible] = (0, react_1.useState)(false);
    const { addErrorAlert } = (0, Alerts_1.useAlert)();
    const handleEditPress = () => {
        setMode(FormItem_1.FormMode.EDIT);
    };
    const handleResetPress = () => {
        if (onResetPress)
            onResetPress();
        setMode(FormItem_1.FormMode.VIEW);
    };
    const handleSaveRequest = (props) => {
        updateFetch(() => dispatchUpdate(props));
    };
    (0, tech_1.useApiStateSuccess)(() => {
        setMode(FormItem_1.FormMode.VIEW);
        if (onUpdateSuccess)
            onUpdateSuccess();
    }, [updateApiState]);
    (0, tech_1.useApiStateError)(() => {
        addErrorAlert({ message: 'Objevila se neočekávaná chyba. Zkuste akci zopakovat později.' });
    }, [updateApiState]);
    const handleDeleteRequest = () => {
        deleteFetch(() => dispatchDelete());
    };
    (0, tech_1.useApiStateSuccess)(() => {
        setIsDeleteModalVisible(false);
        if (onDeleteSuccess)
            onDeleteSuccess();
    }, [deleteApiState]);
    (0, tech_1.useApiStateError)(() => {
        setIsDeleteModalVisible(false);
        if (onDeleteSuccess)
            onDeleteSuccess();
        //FIXME this should not be here, but delete action return invalid JSON
    }, [deleteApiState]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(FormProvider_1.FormProvider, { defaultValues: initValues, onSubmit: handleSaveRequest, children: form => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_ui_1.EditFormHeader, { mode: mode, onEditPress: handleEditPress, onResetPress: () => { form.reset(); handleResetPress(); }, onSavePress: form.submit, onDeletePress: () => setIsDeleteModalVisible(true), isLoading: updateApiState.loading }), children({ mode })] })) }), (0, jsx_runtime_1.jsx)(react_ui_1.DeleteModal, { show: isDeleteModalVisible, onClose: () => setIsDeleteModalVisible(false), isDeleting: deleteApiState.loading, onConfirmPress: handleDeleteRequest })] }));
};
exports.FormWithUpdate = FormWithUpdate;
